import fetch from '../../../common/services/api/fetch';
import getQueryStringForPageIdentifiers from '../getQueryStringForPageIdentifiers';

export default async function addSavedFilter(ids, filter) {
    const queryString = getQueryStringForPageIdentifiers(ids);
    return fetch(
        `/ui/users/preferences/saved_filters/save${queryString}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filter),
        },
        true,
    );
}
